// extracted by mini-css-extract-plugin
module.exports = {"box":"QuestionItem_box__3z0An","inner":"QuestionItem_inner__2MKZt"};